/**
 * currentOrganizationId actions
 */
import { SET_CURRENT_ORGANIZATION_ID } from './constants';

export function setCurrentOrganizationId(organizationId: string) {
    return {
        type: SET_CURRENT_ORGANIZATION_ID,
        payload: {
            organizationId
        }
    };
}
